export default __webpack_public_path__ + "static/media/paywall.9deb6acd.svg";